<template>
	<div class="fillcontain">
		<head-top></head-top>

		<div class="table_container">
			<el-tabs value="first" @tab-click="handleClick">
				<el-tab-pane label="网络媒体" name="first">
					<div class="man-cell" style="margin: 10px">
						<el-input v-model="name" placeholder="媒体名称："></el-input>
					</div>
					<el-button style="margin: 10px" type="primary" @click="getMedia(self)">搜索</el-button>
					<el-button type="primary" @click="
              dialogVisible = true;
              dialogVisible2 = true;
            ">添加新媒体</el-button>

					<!-- <el-button type="primary" @click="gotowithdrawal">收益查看</el-button> -->
					<el-table :data="tableData" highlight-current-row style="width: 100%" v-loading="loading">
						<el-table-column label="媒体名称">
							<template slot-scope="scope">
								<a target="_blank" rel="noopener noreferrer"
									:href="scope.row.mediaCase">{{ scope.row.name }}</a>
							</template>
						</el-table-column>
						<el-table-column property="price" label="价格">
							<template slot-scope="scope">
								<a>{{ scope.row.price }}</a>
							</template>
						</el-table-column>
						<el-table-column property="channel" label="频道类型"></el-table-column>
						<el-table-column property="area" label="地区"></el-table-column>
						<el-table-column property="linkable" label="是否带链接"></el-table-column>
						<el-table-column property="contactable" label="带联系方式"></el-table-column>
						<el-table-column property="rate" label="出稿率"></el-table-column>
						<el-table-column property="speed" label="出稿速度"></el-table-column>
						<el-table-column property="included" label="收录类型"></el-table-column>
						<el-table-column property="auth" label="是否认证">
							<template slot-scope="scope">
								<a v-if="scope.row.auth == '已认证'" class="yrz">{{
                  scope.row.auth
                }}</a>
								<a v-else class="wrz">{{ scope.row.auth }}</a>
							</template>
						</el-table-column>
						<el-table-column property="openid" label="编辑">
							<template slot-scope="scope">
								<el-button size="mini" @click="edit(scope.$index, scope.row)">编辑</el-button>
							</template>
						</el-table-column>
						<!-- <el-table-column property="openid" label="删除">
              <template slot-scope="scope">
                <el-button size="mini" type="danger" @click="dele(scope.$index, scope.row,false)">删除</el-button>
              </template>
            </el-table-column> -->
					</el-table>
					<div class="Pagination" style="text-align: left; margin-top: 10px">
						<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
							:current-page="index" :page-size="20" layout="total, prev, pager, next" :total="count">
						</el-pagination>
					</div>
				</el-tab-pane>
				<el-tab-pane label="自媒体" name="second">
					<div class="man-cell" style="margin: 10px">
						<el-input v-model="name" placeholder="媒体名称："></el-input>
					</div>
					<el-button style="margin: 10px" type="primary" @click="getMedia(self)">搜索</el-button>
					<el-button type="primary" @click="
              dialogVisible_2 = true;
              dialogVisible2 = true;
            ">添加新媒体</el-button>
					<!-- <el-button type="primary" @click="gotowithdrawal">收益查看</el-button> -->
					<el-table :data="tableData" highlight-current-row style="width: 100%" v-loading="loading">
						<el-table-column label="媒体名称">
							<template slot-scope="scope">
								<a target="_blank" rel="noopener noreferrer"
									:href="scope.row.mediaCase">{{ scope.row.name }}</a>
							</template>
						</el-table-column>
						<el-table-column property="price" label="价格">
							<template slot-scope="scope">
								<a>{{ scope.row.price + scope.row.addPrice }}</a>
							</template>
						</el-table-column>
						<el-table-column property="portal" label="媒体平台"></el-table-column>
						<el-table-column property="channel" label="行业类型"></el-table-column>
						<el-table-column property="linkable" label="是否带链接"></el-table-column>
						<el-table-column property="contactable" label="带联系方式"></el-table-column>
						<el-table-column property="rate" label="出稿率"></el-table-column>
						<el-table-column property="speed" label="出稿速度"></el-table-column>
						<el-table-column property="included" label="收录类型"></el-table-column>
						<el-table-column property="auth" label="是否认证">
							<template slot-scope="scope">
								<a v-if="scope.row.auth == '已认证'" class="yrz">{{
                  scope.row.auth
                }}</a>
								<a v-else class="wrz">{{ scope.row.auth }}</a>
							</template>
						</el-table-column>
						<el-table-column property="openid" label="编辑">
							<template slot-scope="scope">
								<el-button size="mini" @click="edit2(scope.$index, scope.row)">编辑</el-button>
							</template>
						</el-table-column>
						<!-- <el-table-column property="openid" label="删除">
              <template slot-scope="scope">
                <el-button size="mini" type="danger" @click="dele(scope.$index, scope.row,true)">删除</el-button>
              </template>
            </el-table-column> -->
					</el-table>
					<div class="Pagination" style="text-align: left; margin-top: 10px">
						<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
							:current-page="index" :page-size="20" layout="total, prev, pager, next" :total="count">
						</el-pagination>
					</div>
				</el-tab-pane>
				<el-tab-pane label="微信公众号" name="3">
					<Offical v-if="mediaType == 3"></Offical>
				</el-tab-pane>
				<el-tab-pane label="微博" name="4">
					<Bolg v-if="mediaType == 4"></Bolg>
				</el-tab-pane>
				<el-tab-pane label="百科问答知识营销" name="5">
					<Wiki v-if="mediaType == 5"></Wiki>
				</el-tab-pane>
				<el-tab-pane label="朋友圈社群" name="6">
					<Wechat v-if="mediaType == 6"></Wechat>
				</el-tab-pane>
				<el-tab-pane label="短视频" name="7">
					<Tiktok v-if="mediaType == 7"></Tiktok>
				</el-tab-pane>
			</el-tabs>
		</div>
		<el-dialog title="添加/修改媒体" :visible.sync="dialogVisible" width="50%">
			<el-form ref="form" label-width="100px">
				<el-form-item label="媒体名称：" style="width: 50%; float: left">
					<el-input style="width: 80%" size="small" v-model="mname"></el-input>
				</el-form-item>
				<el-form-item label="价格：" style="width: 50%; float: left">
					<el-input style="width: 80%" size="small" v-model="mprice"></el-input>
				</el-form-item>
				<el-form-item label="投放类型：" style="width: 50%; float: left">
					<el-select v-model="lanuch" multiple collapse-tags placeholder="请选择">
						<el-option v-for="item in lanuchList" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="其他选项：" style="width: 50%; float: left">
					<el-select v-model="Mothers" placeholder="请选择" multiple @change="changeOthers">
						<el-option v-for="item in othersList" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="频道类型：" style="width: 50%; float: left">
					<el-select v-model="pindao" placeholder="请选择">
						<el-option v-for="item in pindaoList" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="地区：" style="width: 50%; float: left">
					<el-cascader v-model="city" :options="areaList" :props="{ value:'label' }" separator='-' filterable
						clearable @change="choseCity"></el-cascader>
				</el-form-item>
				<el-form-item label="门户：" style="width: 50%; float: left">
					<el-select v-model="portal" placeholder="请选择">
						<el-option v-for="item in portalList" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="带链接：" style="width: 50%; float: left">
					<el-select v-model="link" placeholder="请选择">
						<el-option v-for="item in linkList" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="带联系方式：" style="width: 50%; float: left">
					<el-select v-model="contactable" placeholder="请选择">
						<el-option v-for="item in contactableList" :key="item.value" :label="item.label"
							:value="item.value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="收录类型：" style="width: 50%; float: left">
					<el-select v-model="included" placeholder="请选择">
						<el-option v-for="item in includedList" :key="item.value" :label="item.label"
							:value="item.value"></el-option>
					</el-select>
				</el-form-item>
				<!-- <el-form-item label="是否认证：" style="width:50%;float:left">
          <el-select v-model="auth" placeholder="请选择">
            <el-option
              v-for="item in authList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>-->
				<el-form-item label="案例链接：" style="clear: both">
					<el-input style="width: 80%" type="textarea" size="small" v-model="linkcase"></el-input>
				</el-form-item>
				<el-form-item label="备注：" style="clear: both">
					<el-input style="width: 80%" type="textarea" size="small" v-model="content"></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button v-show="dialogVisible2" type="primary" @click="sureadd(self)">确认添加</el-button>
				<el-button v-show="!dialogVisible2" type="primary" @click="sureedit(self)">确认修改</el-button>
			</span>
		</el-dialog>
		<el-dialog title="添加/修改媒体" :visible.sync="dialogVisible_2" width="50%">
			<el-form ref="form" label-width="100px">
				<el-form-item label="媒体名称：" style="width: 50%; float: left">
					<el-input style="width: 80%" size="small" v-model="mname2"></el-input>
				</el-form-item>
				<el-form-item label="地区：" style="width: 50%; float: left">
					<el-cascader v-model="city" :options="areaList" :props="{ value:'label' }" separator='-' filterable
						clearable @change="choseCity"></el-cascader>
				</el-form-item>
				<el-form-item label="价格：" style="width: 50%; float: left">
					<el-input style="width: 80%" size="small" v-model="mprice2"></el-input>
				</el-form-item>
				<el-form-item label="行业类型：" style="width: 50%; float: left">
					<el-select v-model="pindao2" placeholder="请选择">
						<el-option v-for="item in pindaoList2" :key="item.value" :label="item.label"
							:value="item.value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="粉丝数：" style="width: 50%; float: left">
					<el-input v-model="fans" placeholder="请输入"></el-input>
				</el-form-item>
				<el-form-item label="媒体类型：" style="width: 50%; float: left">
					<el-select v-model="lanuch2" placeholder="请选择">
						<el-option v-for="item in lanuchList2" :key="item.value" :label="item.label"
							:value="item.value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="其他选项：" style="width: 50%; float: left">
					<el-select v-model="others2" placeholder="请选择" multiple>
						<el-option v-for="item in othersList2" :key="item.value" :label="item.label"
							:value="item.value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="所属平台：" style="width: 50%; float: left">
					<el-select v-model="portal2" placeholder="请选择">
						<el-option v-for="(item,index) in portalList2" :key="index" :label="item.label"
							:value="item.value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="带链接：" style="width: 50%; float: left">
					<el-select v-model="link2" placeholder="请选择">
						<el-option v-for="item in linkList2" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="带联系方式：" style="width: 50%; float: left">
					<el-select v-model="contactable2" placeholder="请选择">
						<el-option v-for="item in contactableList2" :key="item.value" :label="item.label"
							:value="item.value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="参考阅读量：" style="width: 50%; float: left">
					<el-input v-model="reading" placeholder="请输入"></el-input>
				</el-form-item>
				<el-form-item label="案例链接：" style="clear: both">
					<el-input style="width: 80%" type="textarea" size="small" v-model="linkcase2"></el-input>
				</el-form-item>
				<el-form-item label="备注：" style="clear: both">
					<el-input style="width: 80%" type="textarea" size="small" v-model="content2"></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible_2 = false">取 消</el-button>
				<el-button v-show="dialogVisible2" type="primary" @click="sureadd2(self)">确认添加</el-button>
				<el-button v-show="!dialogVisible2" type="primary" @click="sureedit2(self)">确认修改</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import HeadTop from "../components/HeadTop";
	import myAxios from "../myAxios";
	import Offical from "../components/myMediaOffical.vue";
	import Bolg from "../components/myMediaBolg.vue";
	import Tiktok from "../components/myMediaTiktok.vue";
	import Wiki from "../components/myMediaWiki.vue";
	import Wechat from "../components/myMediaWechat.vue";
	import areaJson from "../components/area.json";
	import cityList from "../components/city.json";
	export default {
		data() {
			return {
				name: "",
				linkcase: "",
				linkcase2: "",
				fans:'',
				reading:'',
				self: false,
				dialogVisible2: false,
				mname: "",
				mprice: "",
				mediaType: 1,
				sousuo: "",
				mname2: "",
				mprice2: "",
				city: "",
				sousuo2: "",
				username: localStorage.getItem("username"),
				url: localStorage.getItem("url"),
				tableData: [], //用户列表数据
				index: 1, //页码
				size: 20, //页大小
				count: 0, //数据总数
				loading: false, //加载状态
				detail: [],
				dialogVisible: false,
				dialogVisible_2: false,
				content: "",
				content2: "",
				lanuch: "不限",
				lanuch2: "不限",
				showGzh: false,
				showBk: false,
				showWb: false,
				showWx: false,
				showDy: false,
				Mothers:[],
				lanuchList: [{
						value: "不限",
						label: "不限"
					},
					{
						value: "转载",
						label: "转载"
					},
					{
						value: "首发",
						label: "首发"
					},
					{
						value: "焦点图",
						label: "焦点图"
					},
					{
						value: "文字链",
						label: "文字链"
					},
				],
				lanuchList2: [{
						value: "官方网媒认证",
						label: "官方网媒认证"
					},
					{
						value: "个人认证",
						label: "个人认证"
					},
					{
						value: "未认证",
						label: "未认证"
					},
				],
				others: "不限",
				others2: "不限",
				othersList: [{
						value: "不限",
						label: "不限"
					},
					{
						value: "周末可发",
						label: "周末可发"
					},
					{
						value: "秒发",
						label: "秒发"
					},
					{
						value: "节假日可发",
						label: "节假日可发"
					},
					{
						value: "可发视频",
						label: "可发视频"
					},
					{
						value: "可带超链",
						label: "可带超链"
					},
				],
				othersList2: [{
						value: "不限",
						label: "不限"
					},
					{
						value: "周末可发",
						label: "周末可发"
					},
					{
						value: "秒发",
						label: "秒发"
					},
					{
						value: "节假日可发",
						label: "节假日可发"
					},
				],
				pindaoList2: [{
						value: "新闻资讯",
						label: "新闻资讯"
					},
					{
						value: "财经金融",
						label: "财经金融"
					},
					{
						value: "3C科技",
						label: "3C科技"
					},
					{
						value: "家居房产",
						label: "家居房产"
					},
					{
						value: "女性时尚",
						label: "女性时尚"
					},
					{
						value: "母婴亲子",
						label: "母婴亲子"
					},
					{
						value: "汽车",
						label: "汽车"
					},
					{
						value: "娱乐",
						label: "娱乐"
					},
					{
						value: "体育",
						label: "体育"
					},
					{
						value: "文化艺术",
						label: "文化艺术"
					},
					{
						value: "情感",
						label: "情感"
					},
					{
						value: "生活",
						label: "生活"
					},
					{
						value: "设计",
						label: "设计"
					},
					{
						value: "商业",
						label: "商业"
					},
					{
						value: "医疗健康",
						label: "医疗健康"
					},
					{
						value: "电商物流",
						label: "电商物流"
					},
					{
						value: "教育培训",
						label: "教育培训"
					},
					{
						value: "食品餐饮",
						label: "食品餐饮"
					},
					{
						value: "企业服务",
						label: "企业服务"
					},
					{
						value: "其他",
						label: "其他"
					},
				],
				pindao: "",
				areaList2: [{
						value: "1万以下",
						label: "1万以下",
					},
					{
						value: "1万-5万",
						label: "1万-5万",
					},
					{
						value: "5万-10万",
						label: "5万-10万",
					},
				],
				area: "",
				linkList: [{
						value: true,
						label: "是",
					},
					{
						value: false,
						label: "否",
					},
				],
				link: true,
				contactableList: [{
						value: true,
						label: "是",
					},
					{
						value: false,
						label: "否",
					},
				],
				contactable: true,
				includedList2: [
					// 1000以下、1000-5000、 5000-1万、1万-5万、5万-10万、10万以上
					{
						value: "1000以下",
						label: "1000以下",
					},
					{
						value: "1000-5000",
						label: "1000-5000",
					},
					{
						value: "5000-1万",
						label: "5000-1万",
					},
					{
						value: "1万-5万",
						label: "1万-5万",
					},
					{
						value: "5万-10万",
						label: "5万-10万",
					},
					{
						value: "10万以上",
						label: "10万以上",
					},

				],
				included: "",
				authList: [{
						value: true,
						label: "是",
					},
					{
						value: false,
						label: "否",
					},
				],
				auth: true,
				portalList: [{
						value: "新浪",
						label: "新浪",
					},
					{
						value: "网易",
						label: "网易",
					},
					{
						value: "腾讯",
						label: "腾讯",
					},
					{
						value: "搜狐",
						label: "搜狐",
					},
					{
						value: "中国网",
						label: "中国网",
					},
					{
						value: "中国经济网",
						label: "中国经济网",
					},
					{
						value: "人民网",
						label: "人民网",
					},
					{
						value: "新华网",
						label: "新华网",
					},
					{
						value: "光明网",
						label: "光明网",
					},
					{
						value: "中国日报网",
						label: "中国日报网",
					},
					{
						value: "国际在线",
						label: "国际在线",
					},
					{
						value: "央视网",
						label: "央视网",
					},
					{
						value: "和讯网",
						label: "和讯网",
					},
					{
						value: "中华网",
						label: "中华网",
					},
					{
						value: "北青网",
						label: "北青网",
					},
					{
						value: "环球网",
						label: "环球网",
					},
					{
						value: "中国青年网",
						label: "中国青年网",
					},
					{
						value: "中国新闻网",
						label: "中国新闻网",
					},
					{
						value: "南方网",
						label: "南方网",
					},
					{
						value: "北方网",
						label: "北方网",
					},
					{
						value: "慧聪网",
						label: "慧聪网",
					},
					{
						value: "大众网",
						label: "大众网",
					},
					{
						value: "东方网",
						label: "东方网",
					},
					{
						value: "央广网",
						label: "央广网",
					},
					{
						value: "千龙网",
						label: "千龙网",
					},
					{
						value: "海外网",
						label: "海外网",
					},
					{
						value: "中青在线",
						label: "中青在线",
					},
					{
						value: "非门户",
						label: "非门户",
					},
					{
						value: "其他门户",
						label: "其他门户",
					},
				],
				portal: "",
				pindaoList: [],
				pindao2: "",
				areaList: [],
				area2: "",
				linkList2: [{
						value: true,
						label: "是",
					},
					{
						value: false,
						label: "否",
					},
				],
				link2: true,
				contactableList2: [{
						value: true,
						label: "是",
					},
					{
						value: false,
						label: "否",
					},
				],
				contactable2: true,
				includedList: [{
						value: "包网页收录",
						label: "包网页收录",
					},
					{
						value: "网页收录",
						label: "网页收录",
					},
					{
						value: "百度新闻收录",
						label: "百度新闻收录",
					},
					{
						value: "包百度新闻收录",
						label: "包百度新闻收录",
					},
				],
				included2: "",
				reading:"",
				authList2: [{
						value: true,
						label: "是",
					},
					{
						value: false,
						label: "否",
					},
				],
				auth2: true,
				portalList2: [{
						value: "今日头条",
						label: "今日头条"
					},
					{
						value: "百度百家",
						label: "百度百家"
					},
					{
						value: "网易号",
						label: "网易号"
					},
					{
						value: "腾讯号",
						label: "腾讯号"
					},
					{
						value: "新浪头条",
						label: "新浪头条"
					},
					{
						value: "搜狐头条",
						label: "搜狐头条"
					},
					{
						value: "雪球号",
						label: "雪球号"
					},
					{
						value: "一点资讯",
						label: "一点资讯"
					},
					{
						value: "UC头条",
						label: "UC头条"
					},
					{
						value: "凤凰号",
						label: "凤凰号"
					},
					{
						value: "知乎号",
						label: "知乎号"
					},
					{
						value: "小红书",
						label: "小红书"
					},
					{
						value: "简书",
						label: "简书"
					},
					{
						value: "东方财富号",
						label: "东方财富号"
					},
					{
						value: "同花顺",
						label: "同花顺"
					},
					{
						value: "人民全国",
						label: "人民全国"
					},
					{
						value: "人民号",
						label: "人民号"
					},
					{
						value: "新华客户端",
						label: "新华客户端"
					},
					{
						value: "东方头条",
						label: "东方头条"
					},
					{
						value: "搜狐焦点家居",
						label: "搜狐焦点家居"
					},
					{
						value: "UC头条",
						label: "UC头条"
					},
					{
						value: "东方头条",
						label: "东方头条"
					},
					{
						value: "马蜂窝",
						label: "马蜂窝"
					},
					{
						value: "驴妈妈",
						label: "驴妈妈"
					},
					{
						value: "去哪儿",
						label: "去哪儿"
					},
					{
						value: "爱奇艺",
						label: "爱奇艺"
					},
					{
						value: "懂车帝",
						label: "懂车帝"
					},
					{
						value: "其他",
						label: "其他"
					},
				],
				portal2: "",
				city: ""
			};
		},
		components: {
			HeadTop,
			Offical,
			Bolg,
			Tiktok,
			Wiki,
			Wechat,
		},
		created() {
			this.areaList = cityList;
			this.pindaoList = areaJson.typeList;
			this.initData();
		},
		methods: {
			choseCity(e) {
				this.area = e[0] + '-' + e[1]
				console.log(this.area)
			},
			async initData() {
				try {
					this.getMedia(false);
				} catch (err) {
					console.log("获取数据失败", err);
				}
			},
			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
			},
			handleCurrentChange(val) {
				console.log(val);
				this.index = val;
				this.getMedia();
			},
			async getMedia() {
				myAxios
					.get(
						`/client_media/MyMedia/v1?username=${
            this.username
          }&name=${this.name.replace(/\s*/g, "")}&mediaType=${
            this.mediaType
          }&index=${this.index}&size=${this.size}`
					)
					.then((res) => {
						this.tableData = res.data;
						for (var i = 0; i < this.tableData.length; i++) {
							if (this.tableData[i].auth) {
								this.tableData[i].auth = "已认证";
							} else {
								this.tableData[i].auth = "未认证";
							}
							if (this.tableData[i].contactable) {
								this.tableData[i].contactable = "是";
							} else {
								this.tableData[i].contactable = "否";
							}
							if (this.tableData[i].linkable) {
								this.tableData[i].linkable = "是";
							} else {
								this.tableData[i].linkable = "否";
							}
						}
						this.count = res.total;
					});
				this.loading = false;
			},
			gotowithdrawal() {
				this.$router.push({
					path: "/withdrawal"
				});
			},
			changeOthers(e){
				this.others=e.join("-")
				console.log(e);
			},
			edit(index, row) {
				console.log(index, row);
				this.dialogVisible = true;
				this.dialogVisible2 = false;
				this.detail = row;
				this.area = row.area.split("-");
				this.city = row.area.split("-");
				this.pindao = row.channel;
				this.included = row.included;
				this.mname = row.name;
				this.portal = row.portal;
				this.mprice = row.price;
				this.content = row.remark;
				this.linkcase = row.mediaCase;
				this.lanuch = row.lanuch.split("-");
			},
			edit2(index, row) {
				console.log(index, row);
				this.dialogVisible_2 = true;
				this.dialogVisible2 = false;
				this.detail = JSON.parse(JSON.stringify(row)) ;
				this.fans = row.funs;
				this.pindao2 = row.channel;
				this.others2 = row.others.split("-");
				this.fans = row.fans;
				this.reading = row.reading;
				this.mname2 = row.name;
				this.city = row.area.split("-");
				this.area=row.area
				this.portal2 = row.portal;
				this.mprice2 = row.price;
				this.content2 = row.remark;
				this.linkcase2 = row.mediaCase;
				this.lanuch2 = row.lanuch;
			},
			dele(index, row, selfMedia) {
				console.log(index, row);
				this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
				}).then(() => {
					myAxios
						.post(
							`/client_media/DeleteMedia/v1?username=${this.username}&mediaId=${row.id}`
						)
						.then((res) => {
							if (res.code == 0) {
								this.$message({
									type: "success",
									message: res.data,
								});
								this.mname == "";
								this.area == "";
								this.pindao == "";
								this.included == "";
								this.mprice == "";
								this.portal == "";
								this.getMedia();
							} else {
								this.$message({
									type: "success",
									message: res.message,
								});
							}
						});
				});
			},
			sureadd(selfMedia) {
				console.log(this.mname)
				console.log(this.area)
				console.log(this.pindao)
				console.log(this.included)
				console.log(this.mprice)
				console.log(this.portal)
				if (
					this.mname == "" ||
					this.area == "" ||
					this.pindao == "" ||
					this.included == "" ||
					this.mprice == "" ||
					this.portal == ""||
					this.lanuch.length==0
				) {
					this.$alert("信息填写不全", "提示", {
						confirmButtonText: "确定",
					});
					return;
				}
				if (this.mprice <= 0) {
					this.$alert("金额不小于0", "提示", {
						confirmButtonText: "确定",
					});
					return;
				}
				var lanuch = this.lanuch.join("-");
				myAxios
					.post(
						`/client_media/AddMedia/v1?username=${this.username}&mediaType=${this.mediaType}&area=${this.area}&channel=${this.pindao}&contactable=${this.contactable}&included=${this.included}&linkable=${this.link}&name=${this.mname}&portal=${this.portal}&price=${this.mprice}&remark=${this.content}&mediaCase=${this.linkcase}&lanuch=${lanuch}&others=${this.others}`
					)
					.then((res) => {
						if (res.code == 0) {
							this.$message({
								type: "success",
								message: res.data,
							});
							this.getMedia();
							this.mname = "";
							this.area = "";
							this.city=""
							this.pindao = "";
							this.included = "";
							this.mprice = "";
							this.portal = "";
							this.linkcase = "";
							this.content = "";
							this.dialogVisible = false;
						} else {
							this.$message({
								type: "success",
								message: res.message,
							});
						}
					});
			},
			sureedit(selfMedia) {
				console.log("this.mprice");
				console.log(this.mprice);
				if (
					this.mname == "" ||
					this.area == "" ||
					this.pindao == "" ||
					this.included == "" ||
					this.mprice == "" ||
					this.portal == ""||
					this.lanuch.length==0
				) {
					this.$alert("信息填写不全", "提示", {
						confirmButtonText: "确定",
					});
					return;
				}
				if (this.mprice <= 0) {
					this.$alert("金额不小于0", "提示", {
						confirmButtonText: "确定",
					});
					return;
				}
				console.log(this.lanuch);
				var lanuch = this.lanuch.join("-");
				myAxios
					.post(
						`/client_media/UpdateMedia/v1?username=${this.username}&mediaId=${this.detail.id}&area=${this.area}&channel=${this.pindao}&contactable=${this.contactable}&included=${this.included}&linkable=${this.link}&name=${this.mname}&portal=${this.portal}&price=${this.mprice}&remark=${this.content}&mediaCase=${this.linkcase}&lanuch=${lanuch}&others=${this.others}&city=`
					)
					.then((res) => {
						if (res.code == 0) {
							this.$message({
								type: "success",
								message: res.data,
							});
							this.mname == "";
							this.area == "";
							this.city == "";
							this.pindao == "";
							this.included == "";
							this.mprice == "";
							this.portal == "";
							this.getMedia();
							this.dialogVisible = false;
						} else {
							this.$message({
								type: "success",
								message: res.message,
							});
						}
					});
			},
			sureadd2(selfMedia) {
				console.log(this.mname2);
				console.log(this.city);
				console.log(this.fans);
				console.log(this.pindao2);
				console.log(this.included2);
				console.log(this.mprice2);
				console.log(this.portal2);
				var others2=""
				if(this.others2.length>0){
					others2=this.others2.join("-")
				}
				if (
					this.mname2 == "" ||
					this.area == "" ||
					this.fans == "" ||
					this.pindao2 == "" ||
					this.reading == "" ||
					this.mprice2 == "" ||
					this.portal2 == ""
				) {
					this.$alert("信息填写不全", "提示", {
						confirmButtonText: "确定",
					});
					return;
				}
				if (this.mprice2 == 0) {
					this.$alert("金额不小于0", "提示", {
						confirmButtonText: "确定",
					});
					return;
				}
				myAxios
					.post(
						`/client_media/AddMedia/v1?username=${this.username}&mediaType=${this.mediaType}&area=${this.area}&channel=${this.pindao2}&contactable=${this.contactable2}&included=1&linkable=${this.link2}&name=${this.mname2}&portal=${this.portal2}&price=${this.mprice2}&remark=${this.content2}&mediaCase=${this.linkcase2}&lanuch=${this.lanuch2}&others=${others2}&city=${this.city}&fans=${this.fans}&reading=${this.reading}`
					)
					.then((res) => {
						if (res.code == 0) {
							this.$message({
								type: "success",
								message: res.data,
							});
							this.getMedia();
							this.mname2 = "";
							this.fans = "";
							this.pindao2 = "";
							this.city = "";
							this.reading = "";
							this.mprice2 = "";
							this.portal2 = "";
							this.linkcase2 = "";
							this.content2 = "";
							this.dialogVisible_2 = false;
						} else {
							this.$message({
								type: "success",
								message: res.message,
							});
						}
					});
			},
			sureedit2(selfMedia) {
				console.log(this.mname2);
				console.log(this.city);
				console.log(this.fans);
				console.log(this.pindao2);
				console.log(this.reading);
				console.log(this.mprice2);
				console.log(this.portal2);
				if (
					this.mname2 == "" ||
					this.fans == "" ||
					this.pindao2 == "" ||
					this.area == "" ||
					this.reading == "" ||
					this.mprice2 == "" ||
					this.portal2 == ""
				) {
					this.$alert("信息填写不全", "提示", {
						confirmButtonText: "确定",
					});
					return;
				}
				myAxios
					.post(
						`/client_media/UpdateMedia/v1?username=${this.username}&mediaId=${this.detail.id}&area=${this.area}&channel=${this.pindao2}&contactable=${this.contactable2}&included=2&linkable=${this.link2}&name=${this.mname2}&portal=${this.portal2}&price=${this.mprice2}&remark=${this.content2}&mediaCase=${this.linkcase2}&lanuch=${this.lanuch2}&others=${this.others2}&city=${this.city}&fans=${this.fans}&reading=${this.reading}`
					)
					.then((res) => {
						if (res.code == 0) {
							this.$message({
								type: "success",
								message: res.data,
							});
							this.mname2 == "";
							this.fans == "";
							this.pindao2 == "";
							this.city = ""
							this.included2 == "";
							this.mprice2 == "";
							this.portal2 == "";
							this.linkcase2 = "";
							this.content2 = "";
							this.getMedia();
							this.dialogVisible_2 = false;
						} else {
							this.$message({
								type: "success",
								message: res.message,
							});
						}
					});
			},
			handleClick(tab, event) {
				console.log(tab.index);

				this.mediaType = Number(tab.index) + 1;
				if (this.mediaType == 1 || this.mediaType == 2) {
					this.getMedia();
				}
				// if (tab.index == 1) {
				//   this.getMedia();
				// } else {
				//   this.getMedia();
				// }
			},
		},
	};
</script>

<style lang="less">
	@import "../style/mixin";

	.table_container {
		padding: 20px;
	}

	.yrz {
		color: #fd5353;
		border: 1px solid #fd5353;
		border-radius: 5px;
		font-size: 9pt;
		padding: 1px;
	}

	.wrz {
		background-color: #bdbdbd;
		color: #ffffff;
		border-radius: 5px;
		font-size: 9pt;
		padding: 1px;
	}
</style>
